(function() {
	angular.module('pphhApp')
		.service("downloadActionController", ["$mdDialog", "exportService", "$http", DownloadActionController])
		.service("downloadCEActionController", ["$mdDialog", "exportService", "$http", DownloadCEActionController])
		.service("downloadWaterStatusSheetActionController", ["$mdDialog", "exportService", "$http", DownloadWaterStatusSheetActionController])
		.service("downloadActionForceController", ["$mdDialog", "exportService", "$http", DownloadActionForceController])
		.service("downloadUwwActionController", ["$mdDialog", "exportService", "$http", DownloadUwwActionController])
		.service("downloadAruActionController", ["$mdDialog", "exportService", "$http", DownloadUwwActionController])
		.service("DownloadAgeActionController",["$mdDialog", "exportService", "$http", DownloadAgeActionController])

		.controller("downloadDhDialogController", ["$scope", "$mdDialog", "$http", "exportService",
			"lstRbd", "exportTypeId", "configData", DownloadDhDialogController])
		.controller("downloadDhDialogAdviceController", ["$scope", "$mdDialog", "$window", "exportService",
			"typeMsg", "rbd", "idExport", "caducidad", "fpeticion", "formatDownload", "typeTitle", "formatTypeId", "codeCcaa", "codeAdmon", "ambitoModule", "blockErrorMsg",
			DownloadDhDialogAdviceController])
		.controller("downloadCEDialogController", ["$scope", "$mdDialog", "$http", "exportService",
			"lstRbd", "exportTypeId", "configData", DownloadCEDialogController])
		.controller("downloadCcaaDialogController", ["$scope", "$mdDialog", "$http", "exportService",
			"auxCcaaLst", "exportTypeId", "configData", DownloadCcaaDialogController])
		.controller("DownloadAdmonDialogController", ["$scope", "$mdDialog", "$http", "exportService",
			"auxAdmonList","exportTypeId", "configData", DownloadAdmonDialogController])
		.controller("downloadAllDialogController", ["$scope", "$mdDialog", "$http", "exportService",
			"exportTypeId", "configData", DownloadAllDialogController])
		.controller("DownloadAdmonThenAllDhDialogController", ["$scope", "$mdDialog", "$http", "exportService",
		    "auxAdmonList", "rbds", "exportTypeId", "configData", DownloadAdmonThenAllDhDialogController])

		;

	/**
	 * Acción que permite la descarga de la información de un módulo.
	 */
	function DownloadActionController($mdDialog, exportService, $http) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);
		this.performAction = performAction;

		function performAction(scope) {
			helper.performAction(scope, 1, "downloadDhDialogController");
		}
	}
	/**
	 * Acción que permite la descarga de la información de un módulo OIG forzando el dialog
	 */
	function DownloadActionForceController($mdDialog, exportService, $http) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);
		this.performAction = performAction;
		helper.forceDialog = true;
		function performAction(scope) {
			helper.performAction(scope, 1, "downloadAllDialogController");
		}
	}
	/**
	 * Acción que permite la descarga de la información de un módulo en formato CE.
	 */
	function DownloadCEActionController($mdDialog, exportService, $http) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);
		this.performAction = performAction;

		function performAction(scope) {
			helper.performAction(scope, 2, "downloadCEDialogController");
		}
	}

	/**
	 * Acción que permite la descarga de los formularios de estado de masas de agua.
	 */
	function DownloadWaterStatusSheetActionController($mdDialog, exportService, $http) {
		this.performAction = performAction;

		var helper = new DownloadActionHelper($mdDialog, exportService, $http);
		helper.forceDialog = true;

		function performAction(scope) {
			helper.performAction(scope, 4, "downloadDhDialogController");
		}
	}

	function DownloadUwwActionController($mdDialog, exportService, $http) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);

		this.performAction = function(scope) {
			helper.performActionUsingCcaa(scope, 1, "downloadCcaaDialogController");
		}
	}

	function DownloadAgeActionController($mdDialog, exportService, $http) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);

		this.performAction = function (scope) {
			helper.performActionUsingAdmonThenAllDh(scope, 1, "DownloadAdmonThenAllDhDialogController");

		}
	}
	/**
	 * Controlador para el diálogo de descarga estándar para todos los módulos.
	 */
	function DownloadDhDialogController($scope, $mdDialog, $http,
		exportService, lstRbd, exportTypeId, configData) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);

		$scope.dhId = -1;
		$scope.rbds = lstRbd;
		if (lstRbd.length == 1) {
			$scope.dhId = lstRbd[0].id;
		}
		$scope.configData = configData;
		$scope.downloadDH = downloadDH;
		$scope.formatTypeId = 1;

		/**
		 * Realizar la exportacion con la demarcación seleccionada o sobre
		 * todas.
		 */
		function downloadDH() {
			helper.exportCheckRepeatfunction(exportTypeId, $scope.dhId, $scope.formatTypeId, null, null, null);
		}
	}

	function DownloadAllDialogController($scope, $mdDialog, $http,
			exportService, exportTypeId, configData) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);


		$scope.dhId = -1;
		$scope.configData = configData;
		$scope.downloadDH = downloadDH;
		$scope.formatTypeId = 1;

		/**
		 * Realizar la exportacion con la demarcación seleccionada o sobre
		 * todas.
		 */
		function downloadDH() {
			helper.exportCheckRepeatfunction(exportTypeId, $scope.dhId, $scope.formatTypeId, null, null, null);
		}
	}

	function DownloadCcaaDialogController($scope, $mdDialog, $http,
		exportService, auxCcaaLst, exportTypeId, configData) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);

		$scope.dhId = -1;
		$scope.auxCcaaLst = auxCcaaLst;
		$scope.codeCcaa = null;
		if (auxCcaaLst.length === 1) {
			$scope.codeCcaa = auxCcaaLst[0].codCcaa;
		}
		$scope.configData = configData;
		$scope.downloadDH = downloadDH;
		$scope.formatTypeId = 1;

		function downloadDH() {
			helper.exportCheckRepeatfunction(exportTypeId, $scope.dhId, $scope.formatTypeId, $scope.codeCcaa, null, null);
		}

	}

	function DownloadAdmonDialogController($scope, $mdDialog, $http,
										  exportService, auxAdmonList, exportTypeId, configData) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);

		$scope.dhId = -1;
		$scope.auxAdmonList = auxAdmonList;
		$scope.codeAdmon = null;
		if (auxAdmonList.length === 1) {
			$scope.codeAdmon = auxAdmonList[0].idUdOrganica;
		}
		$scope.configData = configData;
		$scope.downloadDH = downloadDH;
		$scope.formatTypeId = 1;

		function downloadDH() {
			helper.exportCheckRepeatfunction(exportTypeId, $scope.dhId, $scope.formatTypeId, null, $scope.codeAdmon, null);
		}

	}

	/**
	 * Controlador para el diálogo de descarga (AGE) con select múltiple (Dh y Admon).
	 */
	function DownloadAdmonThenAllDhDialogController($scope, $mdDialog, $http,
												   exportService, auxAdmonList, lstRbd, exportTypeId, configData) {
		let helper = new DownloadActionHelper($mdDialog, exportService, $http)

		$scope.dhId = -1
		$scope.lstRbd = lstRbd
		$scope.codeAdmon = null
		$scope.auxAdmonList = auxAdmonList
		if (auxAdmonList.length === 1) {
			$scope.codeAdmon = auxAdmonList[0].idUdOrganica
		}
		$scope.configData = configData
		$scope.downloadDH = downloadDH
		$scope.formatTypeId = 1

		$scope.showMessage = false;
		$scope.checkSelections = checkSelections

		function downloadDH() {
			if ($scope.codeAdmon === -1)
				$scope.codeAdmon = null
			helper.exportCheckRepeatfunction(exportTypeId, $scope.dhId, $scope.formatTypeId, null, $scope.codeAdmon, null);

		}

		function checkSelections() {
			let admSelectClicked = false;
			let rbdSelectClicked = false;

			if($scope.codeAdmon !== -1){
				admSelectClicked = true
			}
			if($scope.dhId !== null){
				rbdSelectClicked = true
			}
			$scope.showMessage = admSelectClicked && rbdSelectClicked;
		}
	}

	/**
	 * Controlador para el diálogo de descarga en formato reporting.
	 */
	function DownloadCEDialogController($scope, $mdDialog, $http,
		exportService, lstRbd, exportTypeId, configData) {
		var helper = new DownloadActionHelper($mdDialog, exportService, $http);

		$scope.downloadOption = "opt1";
		$scope.ambitoModule = "15";
		$scope.rbds = lstRbd;
		$scope.downloadDH = downloadDH;
		$scope.downloadUww = downloadUww;

		// realizar la exportacion con la demarcacion y formato seleccionado
		function downloadDH() {
			var option = $scope.downloadOption;

			var exportTypeId = 2;
			var targetDhId = this.dhId;
			if (option === 'opt1') {
				exportTypeId = 3;
				targetDhId = -1;
			}

			helper.exportCheckRepeatfunction(exportTypeId, targetDhId, configData.formats[0].id, null, null, null);

		}
		function downloadUww() {
			var ambitoModule = $scope.ambitoModule;
			var exportTypeId = 2;
			var formatTypeId = 2;

			helper.exportCheckRepeatfunction(exportTypeId, null, formatTypeId, null, null, ambitoModule);

		}
	}


	/**
	 * Clase de utilidad con la funcionalidad común a los distintos tipos de
	 * descargas.
	 */
	function DownloadActionHelper($mdDialog, exportService, $http) {

		this.forceDialog = false;

		this.performAction = performAction;
		this.performActionUsingCcaa = performActionUsingCcaa;
		this.exportCheckRepeatfunction = exportCheckRepeatfunction;
		this.openModalDownloadAdvice = openModalDownloadAdvice;
		this.performActionUsingAdmon = performActionUsingAdmon;
		this.performActionUsingAdmonThenAllDh = performActionUsingAdmonThenAllDh;

		function performActionUsingCcaa(scope, exportTypeId, controller) {
			var force = this.forceDialog;
			exportService.getListAuxCcaaExport()
				.then(function(response) {
					var auxCcaa = response.data;
					openInitModalCcaaDialog(auxCcaa, exportTypeId, controller, force);
				});
		}

		function performActionUsingAdmon(scope, exportTypeId, controller) {
			var force = this.forceDialog;
			exportService.getListAxAdmonExport()
				.then(function(response) {
					var admon = response.data;
					openInitModalAdmonDialog(admon, exportTypeId, controller, force);
				});
		}

		function performActionUsingAdmonThenAllDh (scope, exportTypeId, controller) {
			let force = this.forceDialog;
			exportService.getListAxAdmonExport()
				.then(function(response) {
					let admon = response.data;
					return Promise.all([admon, exportService.getListRbdExport()])
				})
				.then(function([admon, response]) {
					let rbds = response.data;
					openInitModalAdmonThenAllDhDialog(admon, rbds, exportTypeId, controller, force)
				})
		}

		function performAction(scope, exportTypeId, controller) {
			var force = this.forceDialog;
			exportService
				.getListRbdExport()
				.then(
					function(response) {
						var rbds = response.data;
						openInitModalDialog(rbds, exportTypeId, controller, force);
					});
		}


		/**
		 * Muestra el diálogo de selección de demarcación.
		 */
		function openInitModalDialog(rbds, exportTypeId, controller, forceDialog) {
			$http.get("/pphhNav/downloadDialog-config?type=" + exportTypeId)
				.then(function(response) {
					var config = new DownLoadDialogConfig(response);
					/*
				   * Si sólo tiene una demarcación y sólo un formato de descarga
				   * iniciamos la descarga automaticamente.
				   */
					if (config.formats.length === 1 && rbds.length === 1 && !forceDialog) {
						exportCheckRepeatfunction(exportTypeId, rbds[0].id, config.formats[0].id, null, null, null);
					} else {
						$mdDialog.show({
							clickOutsideToClose: true,
							parent: angular.element(document.body),
							locals: {
								lstRbd: rbds,
								exportTypeId: exportTypeId,
								configData: config
							},
							controller: controller,
							templateUrl: "/pphhNav/downloadDialog-init?type=" + exportTypeId
						});
					}
				});
		}

		function openInitModalCcaaDialog(auxCcaa, exportTypeId, controller, force) {
			$http.get("/pphhNav/downloadDialog-config?type=" + exportTypeId)
				.then(function(response) {
					var config = new DownLoadDialogConfig(response);
					$mdDialog.show({
						clickOutsideToClose: true,
						parent: angular.element(document.body),
						locals: {
							auxCcaaLst: auxCcaa,
							exportTypeId: exportTypeId,
							configData: config
						},
						controller: controller,
						templateUrl: "/pphhNav/downloadDialog-init?type=" + exportTypeId
					});
				});
		}

        function openInitModalAdmonDialog(admon, exportTypeId, controller, force) {
            $http.get("/pphhNav/downloadDialog-config?type=" + exportTypeId)
                .then(function(response) {
                    var config = new DownLoadDialogConfig(response);
                    $mdDialog.show({
                        clickOutsideToClose: true,
                        parent: angular.element(document.body),
                        locals: {
                            auxAdmonList: admon,
                            exportTypeId: exportTypeId,
                            configData: config
                        },
                        controller: controller,
                        templateUrl: "/pphhNav/downloadDialog-init?type=" + exportTypeId
                    });
                });
        }

		function openInitModalAdmonThenAllDhDialog(admon, rbds, exportTypeId, controller, force){
			$http.get("/pphhNav/downloadDialog-config?type=" + exportTypeId)
				.then(function(response) {
					let config = new DownLoadDialogConfig(response);
					$mdDialog.show({
						clickOutsideToClose: true,
						parent: angular.element(document.body),
						locals: {
							auxAdmonList: admon,
							rbds: rbds,
							exportTypeId: exportTypeId,
							configData: config
						},
						controller: controller,
						templateUrl: "/pphhNav/downloadDialog-init?type=" + exportTypeId
					});
				});
		}

		function exportCheckRepeatfunction(exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule) {

			exportService.checkExport(exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule).then(
				function(response) {
					$mdDialog.hide();
					if (response.data.result < 0) {
						// hay ya existentes
						openModalDownloadAdvice(response, exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule);
					} else {
						// no hay existentes
						exportService.doExport(exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule)   
							.then(
								function(response) {
									$mdDialog.hide();
									openModalDownloadAdvice(response, exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule);
								});
					}
				});
		}

		/**
		 * muesto pantalla de aviso por si hay existentes o algún error
		 */
		function openModalDownloadAdvice(response, exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule) {
			var exportData = response.data;

			$mdDialog.show({
				clickOutsideToClose: true,
				parent: angular.element(document.body),
				locals: {
					typeMsg: exportData.result,
					rbd: rbdSelected,
					idExport: exportData.id,
					caducidad: exportData.caducidad,
					fpeticion: exportData.fpeticion,
					formatDownload: exportData.formatDownload,
					typeTitle: exportTypeId,
					formatTypeId: formatTypeId,
					codeCcaa: codeCcaa,
					ambitoModule: exportData.ambitoModule,
					codeAdmon: codeAdmon,
					blockErrorMsg: exportData.blockErrorMsg
				},
				controller: "downloadDhDialogAdviceController",
				templateUrl: "/pphhNav/downloadDialogAdvice-init"
			});
		}

		function DownLoadDialogConfig(response) {
			this.warningAdvice = response.data.warningAdvice;
			this.warningModuleAdvice = response.data.warningModuleAdvice;
			this.warningModuleAdviceText = response.data.warningModuleAdviceText;
			this.formats = response.data.formats;
		}
	}

	/**
	 * Controlador asociado al diálog para determinar qué hacer en caso de que existan
	 * descargas ya realizadas candidatas.
	 *
	 * Funciones asociadas a los botones de downloadDhDialogAdvice.jsp
	 */
	function DownloadDhDialogAdviceController($scope, $mdDialog, $window, exportService,
		typeMsg, rbd, idExport, caducidad, fpeticion, formatDownload,typeTitle, formatTypeId, codeCcaa, codeAdmon, ambitoModule, blockErrorMsg) {
		var helper = new DownloadActionHelper($mdDialog, exportService);

		$scope.typeMsg = typeMsg;
		$scope.rbd = rbd;
		$scope.formatTypeId = formatTypeId;
		$scope.idExport = idExport;
		$scope.caducidad = caducidad;
		$scope.fpeticion = fpeticion;
		$scope.formatDownload = formatDownload;
		$scope.typeTitle = typeTitle;
		$scope.codeCcaa = codeCcaa;
		$scope.codeAdmon = codeAdmon;
		$scope.ambitoModule = ambitoModule;
		$scope.blockErrorMsg = blockErrorMsg;

		$scope.newRecord = newRecord;
		$scope.addSubs = addSubs;
		$scope.downSource = downSource;
		$scope.addSubsAnddownSource = addSubsAnddownSource;
		$scope.closeDownloadDH = closeDownloadDH;

		// nuevo registro de exportacion
		function newRecord() {
			$mdDialog.hide();
			exportService.doExport(typeTitle, rbd, formatTypeId, codeCcaa, codeAdmon, ambitoModule).then(
				function(response) {
					helper.openModalDownloadAdvice(response, typeTitle, rbd, formatTypeId, codeCcaa, codeAdmon, ambitoModule);
				});
		}

		// suscribirse a la exportacion
		function addSubs() {
			$mdDialog.hide();
			exportService.callAddSubs(idExport).then(function(response) {
				helper.openModalDownloadAdvice(response, typeTitle, rbd, formatTypeId);
			});
		}

		// descargar un fichero
		function downSource() {
			$mdDialog.hide();
			$window.location.href = exportService
				.callDownloadLink(idExport);
		}

		function addSubsAnddownSource() {
			$mdDialog.hide();
			exportService.callAddSubs(idExport).then(
				function() {
					$window.location.href = exportService
						.callDownloadLink(idExport);
				});
		}

		// cerrar la vetana
		function closeDownloadDH() {
			$mdDialog.hide();
		}
	}

})();